import { VerifiedCell } from '@components/DataGrid';
import { GridRenderCellParams } from '@mui/x-data-grid';
import React from 'react';

const UserEmailCell: React.FC<GridRenderCellParams<string>> = ({
	value,
	row
}) => (
	<VerifiedCell
		value={value || ''}
		isVerified={row.verifiedEmail}
		verifiedTitle={intl.tr('users.email.verified')}
		unverifiedTitle={intl.tr('users.email.unverified')}
	/>
);

export default UserEmailCell;
